/**
 * 
 * @param obj 判断是否为普通对象
 */
export default function isObject(obj : unknown) : obj is Record<string,any> {
    if(obj == null){
        return false
    }
    if(Object.getPrototypeOf){
        let prototype = Object.getPrototypeOf(obj)
        if(obj && typeof obj === 'object' && (prototype === null || prototype === Object.prototype)){
            return true
        }
        return false
    }else{
        return obj && Object.prototype.toString.call(obj) === '[object Object]'
    }
}